export default __webpack_public_path__ + "static/media/Resume_JustinSiu.46798b35.pdf";